:host {
  .invoice {
    gap: 16px;
    display: grid;
    form {
      > span {
        text-align: center;
        padding: 16px 0;
      }
    }
    img {
      right: unset;
      left: unset;
      position: initial;
      transform: none;
    }
    label {
      cursor: pointer;
      font-size: 14px;
      display: flex;
      align-items: flex-start;
      padding: 16px 0;
      input {
        margin: 0 5px 0 0;
        accent-color: #ea662c;
      }
    }
    &-preview {
      display: flex;
      gap: 4px;
      div {
        position: relative;
        button {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0;
          img {
            width: 24px;
            height: 24px;
          }
        }
        > img {
          width: 100px;
          height: 80px;
          object-fit: cover;
        }
      }
    }
    input[type='email'],
    input[type='tel'],
    textarea {
      padding: 16px;
      border: 1px solid #fcd9c9;
      font-size: 16px;
    }
    textarea {
      resize: none;
      height: 200px;
      font-family: 'Inter', sans-serif;
    }
    div:has(> input[type='file']) {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: #fff;
      border: 1px solid #fcd9c9;
      padding: 32px 16px;
      gap: 16px;
      span {
        color: #000;
        font-size: 12px;
      }
    }
    input[type='file'] {
      display: none;
    }
  }
}
